export default __webpack_public_path__ + "static/media/Speaker_List_Example_2.6ddd8eac.png";